import(/* webpackMode: "eager" */ "/codebuild/output/src1882454829/src/github.com/bitstone/offerz-nextjs/src/app/[lang]/(main)/not-found.tsx");
